export default __webpack_public_path__ + "static/cowgirl-9089d2fc07bb85e2df1cb96e8640b44a.svg";